"use client"

import { useEffect } from "react"
import "./globals.css"

/**
 * Last-resort boundary: replaces the root layout entirely, so it has to
 * render its own <html>/<body> and import the stylesheet itself.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error("Global error:", error)
  }, [error])

  return (
    <html lang="en">
      <body className="home bg-paper text-ink antialiased">
        <section className="home-navy relative flex min-h-screen items-center justify-center overflow-hidden px-6 py-32">
          <div
            aria-hidden
            className="pointer-events-none absolute inset-auto -right-[15%] top-[10%] h-[30rem] w-[30rem] rounded-full bg-[radial-gradient(circle,color-mix(in_oklch,var(--home-gold)_16%,transparent)_0%,transparent_68%)]"
          />

          <div className="home-wrap relative z-10 flex flex-col items-center text-center">
            <span className="home-rule" aria-hidden />

            <p className="mt-8 text-xs uppercase tracking-[0.28em] text-[var(--home-gold)]">
              Application error
            </p>

            <p
              aria-hidden
              className="mt-6 font-heading text-[clamp(4.5rem,16vw,11rem)] font-medium leading-[0.85] tracking-[-0.04em] text-[color-mix(in_oklch,var(--home-cream)_22%,transparent)]"
            >
              500
            </p>

            <h1 className="mt-8 max-w-2xl font-heading text-[clamp(2rem,5vw,3.2rem)] font-medium leading-[1.05] tracking-[-0.03em] text-[var(--home-cream)]">
              Something went <span className="text-[var(--home-gold)]">wrong.</span>
            </h1>

            <p className="home-muted mt-6 max-w-xl text-base leading-relaxed">
              The application could not start properly. Please reload the page, and if the
              problem continues, contact us.
            </p>

            <div className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
              <button type="button" onClick={reset} className="home-btn home-btn-gold">
                Try Again
              </button>
              <a href="/" className="home-btn home-btn-ghost">
                Back to Home
              </a>
            </div>
          </div>
        </section>
      </body>
    </html>
  )
}